import { MessageCircle } from 'lucide-react'

const SUPPORT_WHATSAPP = '09132371175'
const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_WHATSAPP.replace(/[^0-9]/g, '')}`

export default function FloatingHelpButton() {
  return (
    <a
      href={SUPPORT_WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-50 inline-flex items-center gap-2 rounded-full bg-primary px-4 py-4 text-sm font-semibold text-primary-foreground shadow-[0_14px_30px_hsl(var(--primary)/0.28)] transition-transform hover:-translate-y-0.5 hover:bg-primary/95"
      aria-label="Get help on WhatsApp"
    >
      <MessageCircle size={18} />
    </a>
  )
}